// @flow

import GooglePublisherTag, { targeting } from '@seek/seek-react-gpt';
import metrics from 'metrics';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { advertsIsEnabled } from 'config';

const createGptLogger = tagId => {
  const match = tagId.match(/\/\d+\/(.*)/);
  const metricTagName = (match !== null) ? match[1] : tagId;

  return () => {
    metrics.count('advertisements', [`tag-id:${metricTagName}`]);
  };
};

const makeHoustonAdTargetingSelector = () => createSelector(
  state => state.search.query,
  state => state.results.location || {},
  (query, location) => ({
    targetingData: targeting.search(query, location)
  })
);

@connect(makeHoustonAdTargetingSelector)
export default class HoustonAd extends Component {
  static propTypes = {
    targetingData: PropTypes.array.isRequired,
    tagId: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  };

  render() {
    const { tagId, targetingData, width, height } = this.props;

    return (
      advertsIsEnabled ?
        <GooglePublisherTag
          tagId={tagId}
          width={width}
          height={height}
          lotameTargeting={true}
          targetingData={targetingData}
          logger={createGptLogger(tagId)}
        /> : null
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HoustonAd/HoustonAd.js
 **/